import { pcLibCodeMap, mobileLibCodeMap } from './adaptRule'
import { cloneDeep } from 'lodash'
export enum TRANSFORM_TYPE {
  CHARACTER = 1,
  USERDEFINE_GROUP = 2
}

export enum TERMINAL_TYPE {
  MOBILE = "3",
  PC = "1"
}

enum CHARACTER_DATA_TYPE {
  LONG = 'Long',
  DECIMAL = 'Decimal'
}

type AdaptParams = {
  transformType?: TRANSFORM_TYPE
  terminalType?: TERMINAL_TYPE,
  structs: any[]
  parentDesc: {
    alias?: string,
    store?: string,
    storeField?: string
  }, // 所属的特征组或自定义项组的描述
  structsMap?: any // 自定义转换关系
}

function jsonParse (jsonstring: string) {
  try {
    return JSON.parse(jsonstring)
  } catch(e) {
    return {}
  }
}

function compose(functions: Function[]) {
  return functions.reduceRight((a, b) => (...args:any[]) => a(b(...args)))
}

export class CharacterAdapter {
  characterMap: Map<string, string> // 转换特征组属性的映射
  constructor() {
    this.characterMap = new Map([
      ['cCaption', 'caption'],
      ['cShowCaptionResid', 'caption_resid'],
      ['name', 'caption'],
      ['nameResId', 'caption_resid'],
      ['cControlType', 'controlType'],
      ['cRefType', 'refCode'],
      ['cEnumType', 'enumType'],
      ['enumType', 'enumType'],
      ['cItemName', 'storeField'],
      ['code', 'storeField'],
      ['iMaxLength', 'maxLength'],
      ['bShowIt', 'visible']
    ])
  }

  adaptStructs = (params: AdaptParams) => {
    const adapter = compose([this.mapProperties, this.addCommonProps, this.addPropsByControlType, this.adaptRefer, this.adaptEnum, this.adaptNumber])
    const { structs: adaptedStructs } = adapter(cloneDeep(params))
    return adaptedStructs
  }

  // 特征组描述 -> ynf协议的映射
  mapProperties = (params: AdaptParams) => {
    const {structs, structsMap} = params
    // 转换协议
    const enableStructsMap = structsMap || this.characterMap
    if (!Array.isArray(structs)) return
    structs.forEach(struct => {
      for (const [key, value] of enableStructsMap) {
        if ((struct[key] !== undefined && struct[key] !== null)) struct[value] = struct[key]
      }
    })
    return params
  }

  addCommonProps = (params: AdaptParams) => {
    const {structs, parentDesc = {}} = params
    structs.forEach(struct => {
      struct.alias = `${parentDesc.alias}_${struct.storeField}`
      struct.store = parentDesc.store
      struct.stateType = "character"
      struct.storeField = parentDesc.storeField ? `${parentDesc.storeField}.${struct.storeField}` : struct.storeField
    })
    return params
  }

  // 处理不同类型特征的libCode等属性
  addPropsByControlType = (params: AdaptParams) => {
    const { structs, terminalType = TERMINAL_TYPE.PC } = params
    const propsMap: {[key:string]: any} = terminalType === TERMINAL_TYPE.PC ? pcLibCodeMap : mobileLibCodeMap

    return {
      ...params,
      structs: structs.map(struct => {
        const extraProps = propsMap[struct.controlType.toLowerCase()]
        return {...struct, ...extraProps}
      })
    }
  }

  // 处理参照字段
  adaptRefer = (params: AdaptParams) => {
    const { structs } = params
    for (const struct of structs) {
      if (!/ReferInput/.test(struct.controlType)) continue
      const refReturnArr: {[key: string]: string} = {} // 带入字段
      let refReturn = [] // 显示字段
      const refCode = struct.refDocCode || struct.refCode
      const extProps = jsonParse(struct.cExtProps)
      const displayname = struct.refRetAttrCode || extProps.displayname || struct.refReturn
      refReturn = [displayname]
      // TODO: 获取主键
      const store = struct.store || ''
      const storeKey = /^mobx:\/\//.test(store) ? store.replace('mobx://rootStore.', '') : store
      refReturnArr.id = `${storeKey},${struct.storeField}`
      if (displayname !== 'id') {
        refReturnArr[displayname] = `${storeKey},${struct.storeField}_${displayname}`
      }
      struct.refCode = refCode
      struct.refReturnArr = JSON.stringify(refReturnArr)
      struct.refReturn = refReturn
      struct.pageStore = 'mobx://rootStore.pageStore'
    }
    return params
  }

  // 处理枚举字段
  adaptEnum = (params: AdaptParams) => {
    const { structs } = params
    for (const struct of structs) {
      if (!/Enumerate/.test(struct.controlType)) continue
      struct.enumData = `mobx://rootStore.pageStore.enumData?.['${struct.enumType}']`
    }
    return params
  }

  // 处理枚举字段
  adaptNumber = (params: AdaptParams) => {
    const { structs, terminalType } = params
    // pc不需要处理, 格式默认为系统类型
    if (terminalType !== TERMINAL_TYPE.MOBILE) return params
    for (const struct of structs) {
      if (!/InputNumber/.test(struct.controlType)) continue
      struct.subuitype = struct.dataType === CHARACTER_DATA_TYPE.LONG ? 'int' : 'decimal'
    }
    return params
  }

}
